import { Lead, Team, Campaign } from './types'

export const MOCK_TEAMS: Team[] = [
  {
    id: 'team_alpha',
    name: 'Alpha Squad',
    description: 'High-volume outbound specialists',
    memberCount: 8,
    colorClass: 'text-blue-700',
    bgClass: 'bg-blue-100',
  },
  {
    id: 'team_beta',
    name: 'Beta Force',
    description: 'Inbound lead conversion',
    memberCount: 6,
    colorClass: 'text-emerald-700',
    bgClass: 'bg-emerald-100',
  },
  {
    id: 'team_gamma',
    name: 'Gamma Group',
    description: 'Enterprise & B2B focus',
    memberCount: 4,
    colorClass: 'text-purple-700',
    bgClass: 'bg-purple-100',
  },
  {
    id: 'team_delta',
    name: 'Delta Ops',
    description: 'Nurture and follow-up',
    memberCount: 5,
    colorClass: 'text-amber-700',
    bgClass: 'bg-amber-100',
  },
]

export const LEAD_SOURCES = [
  'Website Form',
  'Facebook Ad',
  'Google Search',
  'Referral',
  'LinkedIn',
  'TikTok Ad',
  'Email Campaign',
]

export const LEAD_STATES = [
  'CA',
  'TX',
  'FL',
  'NY',
  'PA',
  'IL',
  'OH',
  'GA',
  'NC',
  'MI',
  'WA',
  'AZ',
  'MA',
  'VA',
  'NJ',
  'CO',
  'OR',
  'TN',
]

export const MOCK_CAMPAIGNS: Campaign[] = [
  {
    id: 'camp_new_buyer_intro',
    name: 'New Buyer Intro Sequence',
    description: '7-day welcome drip for new buyer leads',
    status: 'active',
  },
  {
    id: 'camp_seller_nurture',
    name: 'Seller Nurture',
    description: 'Long-term nurture for prospective sellers',
    status: 'active',
  },
  {
    id: 'camp_refi_outreach',
    name: 'Refi Outreach 2026',
    description: 'Refinance opportunity outreach',
    status: 'active',
  },
  {
    id: 'camp_open_house_follow',
    name: 'Open House Follow-up',
    description: 'Same-day follow-up for open house attendees',
    status: 'active',
  },
  {
    id: 'camp_cold_revival',
    name: 'Cold Lead Revival',
    description: 'Re-engagement for aged leads',
    status: 'active',
  },
  {
    id: 'camp_vip_referral',
    name: 'VIP Referral Track',
    description: 'High-touch sequence for referred leads',
    status: 'paused',
  },
]

// Seeded pseudo-random for stable mock data
function mulberry32(seed: number) {
  return function () {
    let t = (seed += 0x6d2b79f5)
    t = Math.imul(t ^ (t >>> 15), t | 1)
    t ^= t + Math.imul(t ^ (t >>> 7), t | 61)
    return ((t ^ (t >>> 14)) >>> 0) / 4294967296
  }
}

const rand = mulberry32(42)
const pick = <T,>(arr: T[]) => arr[Math.floor(rand() * arr.length)]

const TOTAL_LEADS = 3412

export const MOCK_LEADS: Lead[] = Array.from({ length: TOTAL_LEADS }).map(
  (_, i) => {
    const date = new Date()
    // Distribute across the day, weighted toward business hours
    const hour = Math.floor(rand() * rand() * 16) + 6 // 6am-10pm bias
    date.setHours(Math.min(hour, 22))
    date.setMinutes(Math.floor(rand() * 60))
    date.setSeconds(Math.floor(rand() * 60))

    return {
      id: `lead_${10000 + i}`,
      firstName: 'Lead',
      lastName: `#${10000 + i}`,
      email: `lead${10000 + i}@example.com`,
      phone: `(555) 000-0000`,
      source: pick(LEAD_SOURCES),
      state: pick(LEAD_STATES),
      createdAt: date.toISOString(),
    }
  },
)
